import {Asset, AssetType, OperationModeType, Status} from '@hconnect/common/types'
import Moment from 'moment'

let recipeId = 1
const createdOn = Moment('2023-02-01T00:00:00+0000')

export const createAssetWithSingleMode = (id: number): Asset => ({
  id,
  type: AssetType.Crusher,
  createdBy: '',
  name: 'Asset with id ' + id,
  createdOn: createdOn.add(1, 'hours').toISOString(),
  startupCost: 0,
  operationModes: [
    {
      status: Status.Created,
      isOptimized: false,
      name: 'operation mode with id ' + id,
      minimumRuntime: 1,
      id: id,
      type: OperationModeType.Production,
      recipeId: recipeId++,
      throughput: 2,
      powerConsumption: 4
    }
  ],
  status: Status.Created,
  isOptimized: false,
  isShutdownAvailable: false,
  minimumDowntime: 40,
  startCoefficient: 1,
  stopCoefficient: 1
})
